<template>
  <svg
    class="svg-icon"
    :class="iconClass"
    aria-hidden="true"
    viewBox="0 0 1024 1024"
    v-on="$listeners"
  >
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    }
  },
  computed: {
    iconName() {
      return `#${this.iconClass}`
    }
  }
}
</script>

<style>
.svg-icon {
  display: inline-block;
  overflow: hidden;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  font-size: 16px;
  line-height: 1;
  vertical-align: middle;
}
</style>
